import { PracticeAvailability } from '@elation/api-client/src/booking';

/**
 * Takes an array of `PracticeAvailability` objects and returns a map of unique physician ID's
 */
export const getPhysiciansWithHypotheticalAvailabilitySet = (
  availabilities: PracticeAvailability[],
): Set<number> => {
  const physicianIds = availabilities.map((availability) => availability.provider_id);
  const uniquePhysicianIds = new Set(physicianIds);
  return uniquePhysicianIds;
};

/**
 * Takes an array of `PracticeAvailability` objects and returns an array
 * of transformed availability objects
 */
export function transformAvailabilities(
  availabilities: PracticeAvailability[],
): Record<string, string[]> {
  const transformedAvailability: Record<string, string[]> = {};

  availabilities?.forEach((availability) => {
    availability.available_datetimes.sort().forEach((datetime: string) => {
      const [date, time] = datetime.split('T');
      const [hour, minute] = time.split(':');
      if (!transformedAvailability[date]) {
        transformedAvailability[date] = [];
      }
      const formattedTime = `${hour}:${minute}`;
      transformedAvailability[date].push(formattedTime);
    });
  });

  return transformedAvailability;
}
